import { post } from '..';

const updateUserGroupUsers = (
  groupId: string,
  UserId: string[],
  DeletedUserId: string[],
  GroupName: string,
  LocationId: string,
) => post(`users/v2/user-groups/members/${groupId}`, {
  UserId,
  DeletedUserId,
  GroupName,
  LocationId,
});

export default updateUserGroupUsers;
